import { Regex } from '../constants/regex.constants';

export class StringHelper {
    public static lowercaseFirstCharacter(str: string): string {
        if (str && str.length > 0) {
            const firstChar = str.charAt(0).toLowerCase();
            return str.replace(str.charAt(0), firstChar);
        }
        return str;
    }

    public static removeBreakTag(inputString: string): string {
        return inputString.replace(Regex.BreakTags, ' ');
    }
}
